<template>
  <b-overlay
    :show="isOnLoad"
    variant="dark"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
  >
    <div class="managerPopup mediaManagerPopup">
      <div class="managerPopup-top mediaManagerHead">
        <div>
          <div class="mediaManagerEyebrow">Bibliotheque media</div>
          <h3 class="managerPopup-title mediaManagerTitle">Gerer les fichiers du dossier</h3>
          <div class="managerPopup-subtitle mediaManagerSubtitle">
            Importez, parcourez et selectionnez rapidement vos images et documents sans quitter la fiche.
          </div>
          <div class="mediaManagerPath">./{{ folderPayload?.folderClientInfo?.folderName || "..." }}</div>
        </div>
        <div class="mediaManagerActions">
          <div class="mediaManagerBadge">{{ folderContent.length }} fichier<span v-if="folderContent.length > 1">s</span></div>
          <b-button
            v-if="canShowUploader"
            variant="primary"
            class="mediaManagerAddBtn"
            @click="showUploaderAction()"
          >
            <b-icon icon="clipboard-plus"></b-icon>
            Ajouter
          </b-button>
        </div>
      </div>

      <div class="mediaManagerStats">
        <div class="managerPopup-card mediaStatCard" v-if="folderPayload?.folderClientInfo?.maxSize > 0">
          <div class="mediaStatLabel">Espace disque</div>
          <div class="mediaStatValue">{{ folderPayload.folderClientInfo.folderSize }}</div>
          <b-progress :max="folderPayload.folderClientInfo.maxSize" height="10px" class="mediaStatProgress">
            <b-progress-bar :value="folderPayload.folderClientInfo.consumedSize"></b-progress-bar>
          </b-progress>
        </div>

        <div class="managerPopup-card mediaStatCard" v-if="folderPayload?.folderClientInfo?.maxFiles > 0">
          <div class="mediaStatLabel">Nombre de fichiers</div>
          <div class="mediaStatValue">{{ folderContent.length }} / {{ folderPayload.folderClientInfo.maxFiles }}</div>
          <b-progress :max="folderPayload.folderClientInfo.maxFiles" height="10px" class="mediaStatProgress">
            <b-progress-bar :value="folderContent.length"></b-progress-bar>
          </b-progress>
        </div>
      </div>

      <div class="managerPopup-card mediaUploadCard" v-if="showUploader">
        <div class="mediaSectionHead">
          <div>
            <div class="mediaSectionEyebrow">Import</div>
            <div class="mediaSectionTitle">Zone d'upload</div>
          </div>
          <div class="mediaSectionMeta">
            {{ uploadPayload?.acceptTypes === "application/pdf" ? "PDF" : "Images" }}
          </div>
        </div>
        <Uploader :payload="uploadPayload"></Uploader>
      </div>

      <div class="managerPopup-card mediaGalleryCard">
        <List
          :__list="folderContent"
          :__payload="folderPayload"
        ></List>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Uploader from './Uploader';
import List from './List';
export default {
  name: "galerie-manager",
  components: {
    Uploader,
    List,
  },
  props: {
    __payload: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isOnLoad: false,
      uploadPayload: {},
      folderPayload: {},
      showUploader: false,
      folderContent: [],
    };
  },
  computed: {
    listStyle() {
      return this.onEditionId !== null ? 'col-md-4' : 'col-md-12';
    },
    canShowUploader() {
      return !this.showUploader && (
        this.folderPayload?.folderClientInfo?.maxFiles === 0 ||
        this.folderPayload?.folderClientInfo?.maxFiles > this.folderContent.length
      );
    },
  },
  methods: {
    getClientFolder() {
      let $onNext = (response) => {
        if(response.data.length>0) {
          this.folderPayload = this.$props.__payload;
          this.uploadPayload = this.$props.__payload;
          this.folderPayload.folderClientInfo = response.data[0];
          this.uploadPayload.folderClientInfo = response.data[0];
          this.uploadPayload.maxUploadCount = 0;
          this.loadFolder()
        }
      };

      let $onError = (error) => {
        this.isOnLoad = false;
      };

      let $onComplete = () => {
        this.isOnLoad = false;
      };

      this.isOnLoad = true;
      this.__.httpAction({
        methode: 'GET',
        route: '/folders/all/'+ this.$props.__payload.clientID,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    loadFolder() {
      this.isOnLoad = true;
      
      this.folderPayload.onSelect = (attr) => this.onUploadOK(attr);
      this.folderPayload.onDelete = (url, idx) => this.deleteFile(url, idx);
      this.__.loadFolderContent({
          onNext: (data)=>{
            this.folderContent = [].concat(data.data);
            this.uploadPayload.maxUploadCount = this.folderPayload?.folderClientInfo?.maxFiles == 0 ? 10 : (this.folderPayload.folderClientInfo.maxFiles - data.data.length);
            this.isOnLoad = false;
          },
          onComplete: (data) => {},
          onError: () => {
            this.isOnLoad = false;
          },
          folder: this.folderPayload.folderClientInfo.folderName,
        })
    },
    deleteFile(deleteId) {
      let $onNext = (response) => {
        this.isOnLoad = false;
        if(response.data.length>0) {
          this.getClientFolder()
        }
      };
    
      let $onError = (error) => {
        this.isOnLoad = false;
      };

      let $onComplete = () => {
        this.isOnLoad = false;
      };
      
      this.isOnLoad = true;
      this.__.httpAction({
        methode: 'DELETE',
        route: '/folders/files/'+ deleteId,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    showUploaderAction() {
      
      this.showUploader = true;
      this.uploadPayload.onUploadSuccess = () => {this.showUploader = false; this.getClientFolder()};
      this.uploadPayload.onUploadFail = () => {this.getClientFolder()};
      this.uploadPayload.onMaxReached = () => {
        this.$bvModal.msgBoxConfirm(`volume maximale atteint, echec d'envoi de certains fichiers`, {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'OK',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.showUploader = false;
          }
        })
      };
      
    },
  },
  watch: {  
    __payload: function () {
      this.loadData();
    },
  },
  mounted() {
    this.getClientFolder()
  },
};
</script>
<style scoped>
.mediaManagerPopup {
  width: 100%;
}

.mediaManagerHead {
  align-items: flex-start;
}

.mediaManagerEyebrow,
.mediaSectionEyebrow {
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.mediaManagerTitle {
  margin-bottom: 8px;
}

.mediaManagerSubtitle {
  max-width: 720px;
}

.mediaManagerPath {
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(29, 78, 216, 0.08);
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 700;
}

.mediaManagerActions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.mediaManagerBadge {
  padding: 9px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #1e2a44 0%, #31415f 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(30, 42, 68, 0.18);
}

.mediaManagerAddBtn {
  min-width: 130px;
  border-radius: 12px;
  font-weight: 700;
}

.mediaManagerAddBtn .b-icon {
  margin-right: 6px;
}

.mediaManagerStats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.mediaStatCard {
  padding: 18px;
}

.mediaStatLabel {
  margin-bottom: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.mediaStatValue {
  margin-bottom: 12px;
  color: #1e2a44;
  font-size: 18px;
  font-weight: 700;
}

.mediaStatProgress :deep(.progress) {
  background: #e2e8f0;
  border-radius: 999px;
}

.mediaStatProgress :deep(.progress-bar) {
  background: linear-gradient(90deg, #f59e0b 0%, #fb923c 100%);
  border-radius: 999px;
}

.mediaUploadCard,
.mediaGalleryCard {
  padding: 20px;
}

.mediaSectionHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.mediaSectionTitle {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
}

.mediaSectionMeta {
  padding: 8px 14px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

@media (max-width: 991px) {
  .mediaManagerStats {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .mediaManagerHead,
  .mediaSectionHead {
    flex-direction: column;
  }

  .mediaManagerActions {
    width: 100%;
    justify-content: flex-start;
  }

  .mediaUploadCard,
  .mediaGalleryCard,
  .mediaStatCard {
    padding: 16px;
  }
}
</style>
